<template>
  <v-dialog v-model="dialog">
    <v-card class="pb-2">
      <v-card-title class="text-h5 grey lighten-2">
        {{ isNew ? "新增場次" : "修改場次" }}
      </v-card-title>
      <v-card-text class="mt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="text-h6 font-weight-bold">基本資訊</div>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="section.enable"
                label="開放預約"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="3">
              <v-combobox
                :items="衛生所"
                v-model="行政區"
                outlined
                label="*負責衛生所"
                dense
                hide-details
                :rules="[(v) => !!v || '此為必填欄位']"
                :disabled="!!this.$store.state.user.行政區"
              ></v-combobox>
            </v-col>
            <v-col cols="6" sm="3">
              <v-text-field
                label="*年度"
                v-model.number="section.年度"
                outlined
                dense
                hide-details
                :rules="[(v) => !!v || '此為必填欄位']"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3">
              <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="section.日期"
                    :rules="[(v) => !!v || '此為必填欄位']"
                    label="*日期"
                    outlined
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hide-details
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="section.日期"
                  no-title
                  scrollable
                  :show-current="false"
                  locale="zh-tw"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" sm="3">
              <v-text-field
                label="人數上限"
                v-model="section.人數上限"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3">
              <v-text-field
                label="*開始時間"
                v-model="section.開始時間"
                :rules="[
                  (v) => !!v || '',
                  (v) =>
                    /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/.test(v) ||
                    '時間格式錯誤',
                ]"
                outlined
                dense
                hide-details
                placeholder="08:00"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="3">
              <v-text-field
                label="*結束時間"
                v-model="section.結束時間"
                :rules="[
                  (v) => !!v || '',
                  (v) =>
                    /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/.test(v) ||
                    '時間格式錯誤',
                ]"
                outlined
                dense
                hide-details
                placeholder="17:30"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="3">
              <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="section.看報告日期"
                    label="看報告日期"
                    outlined
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="section.看報告日期"
                  no-title
                  scrollable
                  :show-current="false"
                  locale="zh-tw"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" sm="3">
              <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="section.補血補檢日期"
                    label="補血補檢日期"
                    outlined
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="section.補血補檢日期"
                  no-title
                  scrollable
                  :show-current="false"
                  locale="zh-tw"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="*地點"
                :rules="[(v) => !!v || '此為必填欄位']"
                v-model="section.地點"
                outlined
                dense
                hide-details
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6"
              ><v-text-field
                label="地址"
                v-model="section.地址"
                outlined
                dense
                hide-details
              >
              </v-text-field
            ></v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="看報告地點(選填)"
                v-model="section.看報告地點"
                outlined
                dense
                hide-details
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6"
              ><v-text-field
                label="看報告地址(選填)"
                v-model="section.看報告地址"
                outlined
                dense
                hide-details
              >
              </v-text-field
            ></v-col>
          </v-row>
          <div class="text-h6 font-weight-bold mt-6 mb-4">場次篩檢項目</div>
          <v-row>
            <v-col>
              <v-checkbox
                class="check-item"
                label="成健"
                v-model="section.篩檢項目.成健"
              ></v-checkbox>

              <v-checkbox
                class="check-item"
                label="BC肝"
                v-model="section.篩檢項目.BC肝"
              ></v-checkbox>
              <v-checkbox
                class="check-item"
                label="口腔"
                v-model="section.篩檢項目.口腔"
              ></v-checkbox>
              <v-checkbox
                class="check-item"
                label="子抹"
                v-model="section.篩檢項目.子抹"
              ></v-checkbox>
              <v-checkbox
                class="check-item"
                label="乳攝"
                v-model="section.篩檢項目.乳攝"
              ></v-checkbox>
              <v-checkbox
                class="check-item"
                label="大腸"
                v-model="section.篩檢項目.大腸"
              ></v-checkbox>
              <v-checkbox
                class="check-item"
                label="LDCT"
                v-model="section.篩檢項目.LDCT"
              ></v-checkbox>
              <v-checkbox
                class="check-item"
                label="HPV (人類乳突病毒檢查)"
                v-model="section.篩檢項目.HPV"
              ></v-checkbox>
              <v-checkbox
                class="check-item"
                label="胃篩"
                v-model="section.篩檢項目.胃篩"
              ></v-checkbox>
              <v-checkbox
                class="check-item"
                label="ICOPE"
                v-model="section.篩檢項目.ICOPE"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="mt-0" v-if="!isHospital">
            <v-col cols="auto" class="pt-0 pr-3">
              <v-checkbox
                class="check-item"
                label="整合式篩檢"
                v-model="section.整合式篩檢"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto" class="pt-0">
              <v-checkbox
                class="check-item"
                label="顯示問卷"
                v-model="section.顯示問卷"
              ></v-checkbox>
            </v-col>
          </v-row>
          <template v-if="section.篩檢項目.口腔">
            <div class="text-h6 font-weight-bold mt-6 mb-4">口腔篩檢</div>
            <v-row>
              <v-col cols="12" sm="3">
                <v-select
                  v-model="section.口腔支付方式"
                  :items="[
                    '預防保健',
                    '健保醫療給付',
                    '其他公務預算補助',
                    '自費健康檢查',
                    '其他',
                  ]"
                  label="支付方式"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-select
                  v-model="section.口腔篩選地點"
                  :items="['社區或職場設站篩檢', '醫療院所']"
                  label="篩選地點"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-select
                  v-model="section.口腔檢查醫師科別"
                  :items="[
                    '牙科',
                    '耳鼻喉科',
                    '經健康署核可之其他科別專科醫師',
                  ]"
                  label="檢查醫師科別"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="初檢醫療院所代碼"
                  v-model="section.口腔初檢醫療院所代碼"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-if="section.篩檢項目.子抹">
            <div class="text-h6 font-weight-bold mt-6 mb-4">子宮頸抹片檢查</div>
            <v-row>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.子抹支付方式"
                  :items="[
                    '預防保健',
                    '健保醫療給付',
                    '其他公務預算補助',
                    '其他',
                    '難判重做',
                    '自費健康檢查',
                  ]"
                  label="支付方式"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.抹片車及設站篩檢"
                  :items="['否', '抹片車', '設站篩檢']"
                  label="抹片車及設站篩檢"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="抹片檢體取樣機構代碼"
                  v-model="section.抹片檢體取樣機構代碼"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.抹片檢體採檢人員"
                  :items="[
                    '婦產科醫師',
                    '家醫科醫師',
                    '助產士',
                    '公衛護士',
                    '衛生所醫師',
                  ]"
                  label="抹片檢體採檢人員"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.做抹片目的"
                  :items="[
                    '篩檢',
                    '懷疑癌症',
                    '追蹤',
                    '前次抹片難以判讀',
                    '其他',
                  ]"
                  label="做抹片目的"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
          </template>
          <template v-if="section.篩檢項目.乳攝">
            <div class="text-h6 font-weight-bold mt-6 mb-4">
              乳房X光攝影檢查
            </div>
            <v-row>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.乳攝支付方式"
                  :items="[
                    '預防保健',
                    '健保醫療給付',
                    '其他公務預算補助',
                    '自費健康檢查',
                    '其他',
                  ]"
                  label="支付方式"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.乳房攝影車篩檢"
                  :items="['是', '否']"
                  label="乳房攝影車篩檢"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="儀器登設字"
                  v-model="section.乳房攝影儀器登設字"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="所屬單位院所名稱"
                  v-model="section.乳房攝影所屬單位院所名稱"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="所屬單位院所代碼"
                  v-model="section.乳房攝影所屬單位院所代碼"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="車號"
                  v-model="section.乳房攝影車號"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-if="section.篩檢項目.胃篩">
            <div class="text-h6 font-weight-bold mt-6 mb-4">胃癌篩檢</div>
            <v-row>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.胃篩支付方式"
                  :items="[
                    '預防保健',
                    '健保醫療給付',
                    '其他公務預算補助',
                    '自費健康檢查',
                    '其他',
                  ]"
                  label="支付方式"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="採檢單位"
                  v-model="section.胃篩採檢單位"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="醫事機構代碼"
                  v-model="section.胃篩醫事機構代碼"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-if="section.篩檢項目.大腸">
            <div class="text-h6 font-weight-bold mt-6 mb-4">糞便潛血檢查</div>
            <v-row>
              <v-col cols="12" sm="3">
                <v-select
                  v-model="section.糞便潛血支付方式"
                  :items="[
                    '預防保健',
                    '健保醫療給付',
                    '其他公務預算補助',
                    '自費健康檢查',
                    '其他',
                  ]"
                  label="支付方式"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-select
                  v-model="section.糞便潛血篩選地點"
                  :items="[
                    '社區或職場設站篩檢',
                    '門診',
                    '住院',
                    '郵寄',
                    '其他',
                  ]"
                  label="篩選地點"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="檢驗機構代碼"
                  v-model="section.糞便潛血檢驗機構代碼"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  label="檢查醫療院所代碼"
                  v-model="section.糞便潛血檢查醫療院所代碼"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-if="section.篩檢項目.HPV">
            <div class="text-h6 font-weight-bold mt-6 mb-4">HPV 檢查</div>
            <v-row>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.HPV支付方式"
                  :items="[
                    '預防保健',
                    '健保醫療給付',
                    '其他公務預算補助',
                    '自費健康檢查',
                    '其他',
                  ]"
                  label="支付方式"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.HPV抹片車或社區巡迴服務"
                  :items="['否', '抹片車', '社區巡迴服務']"
                  label="抹片車或社區巡迴服務"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="檢查醫事機構代碼（設站單位）"
                  v-model="section.HPV檢查醫事機構代碼"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.HPV檢體取樣醫事人員身分別"
                  :items="[
                    '婦產科醫師',
                    '家醫科醫師',
                    '助產士',
                    '公衛護士',
                    '衛生所醫師',
                    '其他',
                  ]"
                  label="檢體取樣醫事人員身分別"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="section.HPV檢查目的"
                  :items="['篩檢', '追蹤', '其他']"
                  label="檢查目的"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="檢驗實驗室代碼"
                  v-model="section.HPV檢驗實驗室代碼"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <div class="text-h6 font-weight-bold mt-6 mb-4">提醒民眾推播</div>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="section.autoNotify"
                label="自動推播"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <template v-if="section.autoNotify">
            <v-row>
              <v-col cols="12" class="py-1 label">推播方式：</v-col>
              <v-col class="col-auto py-1">
                <v-radio-group
                  v-model="section.notify.type"
                  row
                  hide-details
                  class="mt-0"
                >
                  <v-radio value="line" label="Line" hide-details></v-radio>
                  <v-radio value="sms" label="簡訊" hide-details></v-radio>
                  <v-radio
                    value="auto"
                    label="Line+簡訊"
                    hide-details
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-1 label">推播內容：</v-col>
              <v-col class="py-1">
                <v-textarea
                  v-model="section.notify.content"
                  hint="可用變數 {name}、{id}、{date}、{time}、{place}、{questionnaire}"
                  outlined
                  dense
                  persistent-hint
                ></v-textarea>
              </v-col>
            </v-row>
          </template>
          <div class="text-h6 font-weight-bold mt-6 mb-4">
            截止後提供預約清單
          </div>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="section.reserveListMailEnabled"
                label="啟用寄送預約清冊"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false"> 關閉 </v-btn>
        <v-btn color="primary" @click="update" v-if="isNew"> 確定新增 </v-btn>
        <v-btn color="primary" @click="update" v-else> 儲存修改 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { 行政區 } from "@/libs/const";
import util from "@/mixins/util";
export default {
  name: "SectionDialog",
  props: ["value", "theSection"],
  mixins: [util],
  data: () => ({
    valid: false,
    section: null,
    datePicker: false,
    行政區: null,
  }),
  computed: {
    衛生所() {
      let place = 行政區.map((v) => ({
        text: v + "衛生所",
        value: v,
      }));
      return place;
    },
    isNew() {
      return !this.section?._id;
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  async created() {
    this.section = { ...this.theSection };
    let 行政區 = this.section.行政區 || this.$store.state.user.行政區;
    this.行政區 = this.衛生所.find((row) => row.value == 行政區);
    if (!this.section.notify) {
      this.section.notify = {
        type: "auto",
        content: "{name}你好，您已預約全民健檢，請於{date} {time}至{place}。",
      };
    }
    if (this.section.reserveListMailEnabled === undefined) {
      this.section.reserveListMailEnabled = false;
    }
  },
  methods: {
    async update() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        try {
          await this.axios.post("/dashboard/section", this.section);
          this.dialog = false;
          this.$toast.success(this.section._id ? "修改成功" : "新增成功");
          this.$emit("load");
        } catch (e) {
          this.$toast.error(this.section._id ? "修改失敗" : "新增失敗");
        }
      }
    },
  },
  watch: {
    行政區(val) {
      this.section.行政區 = val && val.value ? val.value : val;
    },
    "section.整合式篩檢"(val) {
      if (val) {
        this.section.篩檢項目.成健 = true;
        this.section.篩檢項目.BC肝 = true;
        this.section.篩檢項目.口腔 = true;
        this.section.篩檢項目.子抹 = true;
        this.section.篩檢項目.乳攝 = true;
        this.section.篩檢項目.大腸 = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.check-item {
  width: 120px;
  display: inline-block;
}
</style>
